import arMessages from "../locales/ar_AE.json";
import { LangConfig } from "../model";

export const ArLang: LangConfig = {
  messages: {
    ...arMessages,
  },
  locale: "ar-AE",
};
